export const navLinks = [
  { label: "平台特色", href: "#features" },
  { label: "漫画库", href: "#library" },
  { label: "阅读体验", href: "#reading" },
  { label: "APP下载", href: "#download" },
  { label: "最新地址", href: "#address" },
  { label: "使用教程", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export const heroStats = [
  { value: "20,000+", label: "收录漫画作品" },
  { value: "800万+", label: "注册读者" },
  { value: "1,500+", label: "日均更新章节" },
  { value: "99.9%", label: "阅读服务可用率" },
];

export const features = [
  {
    icon: "ri-book-shelf-line",
    title: "海量漫画库",
    desc: "玄幻、都市、恋爱、科幻、武侠、悬疑、国风、日常等全品类覆盖，数万部作品持续入库，冷门口味也能被满足。",
  },
  {
    icon: "ri-image-2-line",
    title: "高清全彩阅读",
    desc: "支持标清 / 高清 / 超清画质自由切换，长图自动拼接，手机小屏也能看清每一格分镜的细节。",
  },
  {
    icon: "ri-cloud-line",
    title: "多端同步书架",
    desc: "网页版与 APP 账号互通，书架、阅读进度、收藏与订阅在手机、平板、电脑之间实时同步。",
  },
  {
    icon: "ri-notification-3-line",
    title: "智能更新提醒",
    desc: "关注的作品一旦更新，第一时间推送提醒；周更、月更、完结状态一目了然，不再错过关键剧情。",
  },
  {
    icon: "ri-moon-clear-line",
    title: "纯净阅读模式",
    desc: "无弹窗、无遮挡的阅读界面，支持夜间模式、护眼底色、翻页方式与字号自定义，久看不累眼。",
  },
  {
    icon: "ri-shield-check-line",
    title: "稳定入口保障",
    desc: "官方长期维护多条访问线路，遇到域名调整也能快速找到本站，收藏本页即可随时回来。",
  },
];

export const readingThemes = [
  { id: "paper", name: "米白纸张", className: "bg-background-100", text: "text-foreground-900" },
  { id: "eye", name: "护眼豆绿", className: "bg-secondary-100", text: "text-foreground-900" },
  { id: "night", name: "夜间模式", className: "bg-foreground-900", text: "text-background-100" },
];

export const downloadPlatforms = [
  {
    icon: "ri-apple-line",
    name: "iOS 客户端",
    version: "v3.8.2",
    meta: "适配 iPhone / iPad · 需 iOS 14 及以上",
    size: "78 MB",
    note: "App Store 与 TestFlight 双通道，主题与夜间模式完整支持。",
  },
  {
    icon: "ri-android-line",
    name: "Android 客户端",
    version: "v3.8.2",
    meta: "适配 Android 手机 / 平板 · 需 Android 8 及以上",
    size: "63 MB",
    note: "支持后台缓存与离线下载，弱网环境自动降级画质。",
  },
  {
    icon: "ri-computer-line",
    name: "Windows 客户端",
    version: "v3.7.9",
    meta: "适配 Windows 10 / 11",
    size: "112 MB",
    note: "大屏阅读体验更佳，支持键盘翻页与双页对开。",
  },
  {
    icon: "ri-macbook-line",
    name: "macOS 客户端",
    version: "v3.7.6",
    meta: "适配 macOS 12 及以上",
    size: "124 MB",
    note: "适配视网膜屏，长图滚动流畅，书架与网页版同步。",
  },
  {
    icon: "ri-global-line",
    name: "网页版（免安装）",
    version: "持续更新",
    meta: "支持主流现代浏览器",
    size: "无需下载",
    note: "打开即读，无需安装任何程序，适合临时追更。",
  },
];

export const updateLogs = [
  {
    version: "v3.8.2",
    date: "2026 年 9 月",
    items: ["新增“追更日历”，按周查看关注的更新", "修复长图在部分机型偶发错位的问题", "优化夜间模式下的对比度与亮度过渡"],
  },
  {
    version: "v3.8.0",
    date: "2026 年 7 月",
    items: ["书架支持自定义分组与排序", "新增离线缓存队列与批量管理", "启动速度提升约 30%"],
  },
  {
    version: "v3.7.6",
    date: "2026 年 5 月",
    items: ["新增护眼豆绿阅读底色", "分镜双击缩放更顺滑", "优化备用线路自动切换逻辑"],
  },
];

export const entranceLines = [
  {
    icon: "ri-home-4-line",
    name: "官方主站线路",
    desc: "默认推荐线路，访问速度稳定，适合日常追更与收藏同步。",
    status: "推荐",
  },
  {
    icon: "ri-speed-up-line",
    name: "移动数据线路",
    desc: "针对手机流量网络优化，弱网环境下加载更顺畅。",
    status: "稳定",
  },
  {
    icon: "ri-earth-line",
    name: "海外访问线路",
    desc: "为境外或跨区域访问场景准备的备用入口，连接更稳定。",
    status: "备用",
  },
  {
    icon: "ri-smartphone-line",
    name: "APP 内置入口",
    desc: "已安装客户端的读者，可跳过网页直接进入书架与追更页。",
    status: "已安装用户",
  },
];

export const guideWebSteps = [
  { title: "打开本站", desc: "在本页收藏官方地址，随时可从收藏夹回到包子漫画。" },
  { title: "进入漫画库", desc: "在“漫画库”分区按分类或标签筛选，找到想看的作品。" },
  { title: "选择作品", desc: "点击封面查看作品简介、更新状态与最新章节信息。" },
  { title: "开始阅读", desc: "进入阅读页后可按个人习惯调整画质、底色与翻页方式。" },
];

export const guideAppSteps = [
  { title: "选择设备", desc: "在“APP下载”分区选择对应的系统版本（iOS / Android / 桌面端）。" },
  { title: "下载安装", desc: "下载完成后按系统提示完成安装，首次启动可能需要允许安装来源。" },
  { title: "登录同步", desc: "使用同一账号登录，书架、收藏与阅读进度会自动同步到云端。" },
  { title: "离线缓存", desc: "在作品页选择要缓存的章节，通勤或弱网时也能离线阅读。" },
];

export const faqs = [
  {
    q: "包子漫画可以免费看吗？",
    a: "本站提供大量免费阅读的漫画章节，覆盖玄幻、都市、恋爱、科幻、武侠等多个品类。部分作品可能包含需要登录或额外条件才能阅读的内容，具体以阅读页展示的说明为准。",
  },
  {
    q: "网页版和 APP 有什么区别？",
    a: "网页版免安装、打开即读，适合临时追更；APP 在网页版基础上增加了离线缓存、更新推送、多端书架同步与更完整的阅读设置，适合长期追更的读者。两者账号互通，数据同步。",
  },
  {
    q: "官网域名打不开怎么办？",
    a: "由于网络环境可能变化，访问域名会不定期调整。建议收藏本页面，并在“最新地址”分区查看当前可用的入口线路；如仍无法访问，可尝试切换移动数据或更换网络环境后再打开。",
  },
  {
    q: "如何在 APP 里同步书架？",
    a: "在网页版与 APP 使用同一账号登录即可。登录后书架、收藏、阅读进度会自动上传到云端，在新设备登录同一账号后会自动恢复，无需手动导入。",
  },
  {
    q: "下载的漫画会占用很多空间吗？",
    a: "离线缓存的占用取决于你缓存的章节数量与画质，可在设置中调整缓存画质并清理已读章节。建议保留常用作品，定期清理旧缓存以节省存储空间。",
  },
  {
    q: "为什么有的漫画更新比较慢？",
    a: "漫画更新节奏由作品本身的发布计划决定，周更、双周更甚至月更都很常见。你可以在作品页查看更新状态，并开启更新提醒，作品上新时会第一时间通知你。",
  },
  {
    q: "支持哪些设备阅读？",
    a: "网页版支持主流的桌面与移动浏览器；客户端覆盖 iOS、Android、Windows 与 macOS。旧版本系统可能无法安装最新客户端，建议先升级系统或使用网页版阅读。",
  },
  {
    q: "遇到问题怎么反馈？",
    a: "你可以在“使用教程”与“常见问题”分区先查阅自助说明；若问题仍未解决，可在客户端内的“我的—帮助与反馈”提交问题描述，并附上截图，方便更快定位。",
  },
];

export const footerColumns = [
  {
    title: "站内导航",
    links: [
      { label: "平台特色", href: "#features" },
      { label: "漫画库", href: "#library" },
      { label: "阅读体验", href: "#reading" },
      { label: "APP下载", href: "#download" },
    ],
  },
  {
    title: "帮助支持",
    links: [
      { label: "最新地址", href: "#address" },
      { label: "使用教程", href: "#guide" },
      { label: "常见问题", href: "#faq" },
      { label: "平台概览", href: "#stats" },
    ],
  },
];

export const tickerItems = [
  "《灵域行者》第 512 话已更新",
  "《星辰剑歌》本周人气榜第一",
  "《校园恋语》全平台免费看至第 100 话",
  "《甜蜜便利店》新增深夜剧场篇",
  "《山海异闻录》青丘之约篇章开启",
  "《机械纪元》客户端专属高清算力开放",
];